const typeLayoutOverrides = {
  simpleActionItem: {
    desktopLayout:
      [
        ['name'],
        ['dueDate', 'priority'],
        ['status', 'timeToComplete'],
        ['assignedTo', 'showOnBlueprint'],
        ['description'],
      ],
  },
  householdEscalation: {
    mobileLayout: [
      ['escalationType'],
      ['escalationNote'],
      ['saveAgent'],
    ],
    desktopLayout: [
      ['escalationType'],
      ['escalationNote'],
      ['saveAgent'],
    ],
  },
  externalForm: {
    mobileLayout: [
      ['status'],
      ['reviewDocument'],
      ['reviewed'],
    ],
    desktopLayout: [
      ['status'],
      ['reviewDocument'],
      ['reviewed'],
    ],
  },
  account: {
    desktopLayout: [],
  },
  bulkCommunication: {
    desktopLayout: [],
  },
  curatedContentArticle: {
    mobileLayout: [
      ['name'],
      ['category'],
      ['contentUrl'],
      ['minAge'],
      ['maxAge'],
    ],
    desktopLayout: [
      ['name'],
      ['category'],
      ['contentUrl'],
      ['minAge'],
      ['maxAge'],
    ],
  },
  bulkCommunicationPreview: {
    mobileLayout: [
      ['bulkCommunicationId'],
    ],
    desktopLayout: [
      ['bulkCommunicationId'],
    ],
  },
  // DO NOT REMOVE - GENERATOR REPLACE ME
};

export default typeLayoutOverrides;
